module.exports = __webpack_public_path__ + "img/plant_5.ac614200.webp";